import React, { useContext, useEffect, useState } from "react";
import { BACKEND_API } from "../../constants/backendApi";

//Style
import "./MoreInfoDataFormBody.css";

//Data
import moreInfoDataInputs from "../../json/CreateCreditData/MoreInfoDataFormInputs.json";

//Components
import FormWithStepsComponent from "../FormWithStepsComponent/FormWithStepsComponent";

//Context
import { PopupContext } from "../../context/PopupContext";

const MoreInfoDataFormBody = () => {
  const { setShowPopup, setPopupData } = useContext(PopupContext);

  const isFromWhatsapp = localStorage.getItem("is_from_whatsapp");
  const formId = localStorage.getItem("form_id");
  const token = localStorage.getItem("token");

  useEffect(() => {
    if (isFromWhatsapp) {
      try {
        fetch(`${BACKEND_API}/api/credit-ocr?id=${formId}`, {
          method: "GET",
          credentials: "include",
          headers: {
            Authorization: `Bearer ${token}`,
          },
        })
          .then((res) => res.json())
          .then((data) => {
            switch (data.message) {
              case "informacion creditos":
                if (data.data.FuenteCreacion === "whatsapp") {
                  setPopupData({
                    title: "Enviado Exitosamente",
                    isFromWhatsapp: true,
                    info: `El crédito ya se finalizó.`,
                    type: "error",
                  });
                  setShowPopup(true);
                }
                break;

              default:
                break;
            }
          });
      } catch (err) {
        console.error(err);
      }
    }
  }, []);

  return (
    <section className="more-info-data-form-section">
      <div className="more-info-data-form-subcontainer">
        <div className="form-with-steps-supercontainer">
          <FormWithStepsComponent
            inputData={moreInfoDataInputs.data[0]}
            hasSteps={false}
            hasRestoreBtn={false}
          />
        </div>
        <img
          src="https://pagina-crediseguro.s3.amazonaws.com/portal-crediseguro/assets/bgs/woman-deco-img-2.webp"
          className="profile-deco"
          alt=""
        />
      </div>
    </section>
  );
};

export default MoreInfoDataFormBody;
